//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import { translate } from 'react-i18next';
import { actionsBarFactory } from 'common/entity/ActionsBar';
import { ButtonWithPopover, ButtonTypes } from 'common/components/core/button';
import { dashboardColors } from 'common/enums/ColorEnum';
import defaultTheme from './PjpNavigationActionsBar.scss';
import pjpPlansIds from 'common/tests/masterManagement/pjpPlans.json';
import testIds from 'common/tests/fieldPro/createPlanIds.json';

type Props = {
    entityNameId?: string,
    selectedRows?: string,
    title: string,
    t: string,
    isNextDisabled?: boolean,
    theme?: Object,
    isLoading?: boolean,
    filteredEntriesCount?: number,
    filteringEnabled?: boolean,
    allFilteredEntitiesSelected?: boolean,
    pageSize?: number,
    enableFilteredEntitiesSelection?: boolean,
    resetSelectedRows?: () => void,
    onSelectAllFilteredEntities: () => void,
    onNext?: () => void,
    onPrev?: () => void
};

class CreatePjpNavigation extends React.PureComponent {
    onCancel = () => {
        const { onCancel } = this.props;
        onCancel();
    };
    render() {
        const {
            theme,
            t,
            isNextDisabled,
            onNext,
            errorMessage,
            onPrev
        } = this.props;
        return (
            <div className={theme.rightNavigation}>
                <ButtonWithPopover
                    theme={theme}
                    buttonType={ButtonTypes.Solid}
                    color={dashboardColors.paleGreyThree.name}
                    onClick={this.onCancel}
                    label={t('cancel')}
                    semibold
                    uppercase
                    data-test-id={testIds.cancelAction}
                />
                {onPrev ? (
                    <ButtonWithPopover
                        semibold
                        uppercase
                        disabled={!onPrev}
                        theme={theme}
                        testId={
                            !onPrev
                                ? pjpPlansIds.outlet.previousButtonDisabled
                                : pjpPlansIds.outlet.previousButton
                        }
                        buttonType={ButtonTypes.Solid}
                        color={dashboardColors.darkSkyBlue.name}
                        onClick={onPrev}
                        label={t('previous')}
                        data-test-id={testIds.previousAction}
                    />
                ) : null}
                <ButtonWithPopover
                    semibold
                    uppercase
                    disabled={isNextDisabled}
                    isPopOverOpen={!!errorMessage}
                    theme={theme}
                    testId={
                        isNextDisabled
                            ? pjpPlansIds.outlet.nextButtonDisabled
                            : pjpPlansIds.outlet.nextButton
                    }
                    buttonType={ButtonTypes.Solid}
                    color={dashboardColors.darkSkyBlue.name}
                    onClick={onNext}
                    label={t('next')}
                    popOverContent={errorMessage}
                    data-test-id={testIds.nextAction}
                />
            </div>
        );
    }
}
const DefaultPjpNavigationActionsBar = actionsBarFactory({
    RightComponent: CreatePjpNavigation
});

class PjpNavigationActionsBar extends React.PureComponent<Props> {
    onNext = () => {
        const {
            onNext,
            selectedRows,
            allApplicableFilters,
            allFilteredEntitiesSelected,
            filteredEntriesCount
        } = this.props;
        onNext &&
            onNext({
                selectedRows,
                allApplicableFilters,
                allFilteredEntitiesSelected,
                filteredEntriesCount
            });
    };

    onSelectAllFilteredEntities = () => {
        const { onSelectAllFilteredEntities } = this.props;
        onSelectAllFilteredEntities && onSelectAllFilteredEntities();
    };

    render() {
        const {
            entityNameId,
            selectedRows,
            title,
            t,
            isNextDisabled,
            theme,
            isLoading,
            filteredEntriesCount,
            filteringEnabled,
            allFilteredEntitiesSelected,
            onSelectAllFilteredEntities,
            resetSelectedRows,
            pageSize,
            enableFilteredEntitiesSelection,
            onNext,
            onPrev,
            onCancel,
            errorMessage,
            noConfigError,
            isEmptyState
        } = this.props;
        return (
            <DefaultPjpNavigationActionsBar
                filteringEnabled={filteringEnabled}
                filteredEntriesCount={filteredEntriesCount}
                selectedRows={selectedRows}
                entityNameId={entityNameId}
                title={title}
                disableColumnModifier
                theme={theme}
                t={t}
                onNext={onNext && this.onNext}
                onPrev={onPrev}
                onCancel={onCancel}
                errorMessage={errorMessage || noConfigError}
                isNextDisabled={
                    isEmptyState ||
                    isNextDisabled ||
                    (selectedRows && selectedRows.length === 0)
                }
                allFilteredEntitiesSelected={allFilteredEntitiesSelected}
                onSelectAllFilteredEntities={onSelectAllFilteredEntities}
                resetSelectedRows={resetSelectedRows}
                pageSize={pageSize}
                isLoading={isLoading}
                enableFilteredEntitiesSelection={
                    enableFilteredEntitiesSelection
                }
            />
        );
    }
}

const EnhancedPjpNavigationActionsBar = themr(
    'PjpNavigationActionsBar',
    defaultTheme
)(translate('entityManagement')(PjpNavigationActionsBar));

export { EnhancedPjpNavigationActionsBar as PjpNavigationActionsBar };

export default EnhancedPjpNavigationActionsBar;
